import { createStore, applyMiddleware, compose } from "redux";
import { thunk } from "redux-thunk"; // Import the entire redux-thunk package
import rootReducer from "./reducers"; // Import your root reducer
import { environmentConstants } from "../constants";

// Function to create store enhancers with Redux DevTools
const createEnhancers = () => {
  if (
    process.env.REACT_APP_ENVIRONMENT === environmentConstants.DEVELOPMENT &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
  ) {
    return window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
      trace: true,
      traceLimit: 25,
    });
  }
  return compose;
};

const createMiddleware = () => applyMiddleware(thunk);

const configureStore = () => {
  const enhancers = createEnhancers();
  const middleware = createMiddleware();

  return createStore(rootReducer, enhancers(middleware));
};

const store = configureStore();

export default store;
